/* sc-popup.js — popup "Giảm 20% cho đơn đầu tiên", hiện MỖI LẦN khách vào lại web (mỗi lượt truy cập).
 * Đóng popup → không hiện lại trong lượt đó. Đã đăng ký nhận mã → không hiện nữa.
 * Cấu hình trong theme/snippets/simple-candy.liquid:
 *   window.SC_POPUP = { code, percent, delay, image, skip }
 * Gửi form "customer" chuẩn của Shopify → khách vào mục Khách hàng (đăng ký nhận email, tag "popup-20").
 * Mã giảm giá phải được admin tạo trong Shopify › Giảm giá (đúng tên code).
 * Đăng ký xong mã được áp sẵn vào giỏ (/discount/<code>). */
(function () {
  var W = window, D = document, C = W.SC_POPUP || {};
  if (W.__scPopup || C.skip) return;
  W.__scPopup = 1;

  var CODE = C.code || 'SIMPLE20', PCT = C.percent || 20, DELAY = C.delay == null ? 4000 : C.delay;
  var KEY = 'sc_popup', SKEY = 'sc_popup_closed'; // KEY: đã đăng ký (lưu lâu dài) · SKEY: đã đóng trong lượt này
  if (/^\/(cart|checkouts?|account|challenge|password|policies)(\/|$)/.test(location.pathname)) return;

  function store(v) { try { v === undefined ? 0 : localStorage.setItem(KEY, JSON.stringify(v)); return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  var state = store();
  var posted = /[?&]customer_posted=true/.test(location.search);
  var recent = state && state.s === 'sent' && Date.now() - (state.t || 0) < 30 * 60e3;
  if (posted && recent) { ready(function () { build(); success(); }); return; }
  if (recent && /scw/.test(location.hash)) { // quay về nhưng Shopify chưa nhận (vd email sai) → mở lại kèm lỗi
    ready(function () { build(); open(); var m = root.querySelector('.scw-msg'), i = root.querySelector('input[type=email]'); if (i && state.email) i.value = state.email; if (m) m.textContent = 'Chưa gửi được, bạn kiểm tra email và thử lại nhé.'; });
    store({ s: 'open', t: Date.now() });
    return;
  }
  if (state && state.s === 'done') return;
  try { if (sessionStorage.getItem(SKEY)) return; } catch (e) {}

  function ready(f) { D.readyState === 'loading' ? D.addEventListener('DOMContentLoaded', f) : f(); }

  var F = '/cdn/shop/files/';
  var CSS = ''
    + '@font-face{font-family:"SCW Baloo";font-weight:500 800;font-display:swap;src:url(' + F + 'scr-fonts-baloo2-vietnamese.woff2) format("woff2");unicode-range:U+0102-0103,U+0110-0111,U+0128-0129,U+0168-0169,U+01A0-01A1,U+01AF-01B0,U+0300-0301,U+0303-0304,U+0308-0309,U+0323,U+0329,U+1EA0-1EF9,U+20AB}'
    + '@font-face{font-family:"SCW Baloo";font-weight:500 800;font-display:swap;src:url(' + F + 'scr-fonts-baloo2-latin.woff2) format("woff2")}'
    + '@font-face{font-family:"SCW Sans";font-weight:400;font-display:swap;src:url(' + F + 'scr-fonts-bevietnampro-400-vietnamese.woff2) format("woff2");unicode-range:U+0102-0103,U+0110-0111,U+0128-0129,U+0168-0169,U+01A0-01A1,U+01AF-01B0,U+0300-0301,U+0303-0304,U+0308-0309,U+0323,U+0329,U+1EA0-1EF9,U+20AB}'
    + '@font-face{font-family:"SCW Sans";font-weight:400;font-display:swap;src:url(' + F + 'scr-fonts-bevietnampro-400-latin.woff2) format("woff2")}'
    + '@font-face{font-family:"SCW Sans";font-weight:600;font-display:swap;src:url(' + F + 'scr-fonts-bevietnampro-600-vietnamese.woff2) format("woff2");unicode-range:U+0102-0103,U+0110-0111,U+0128-0129,U+0168-0169,U+01A0-01A1,U+01AF-01B0,U+0300-0301,U+0303-0304,U+0308-0309,U+0323,U+0329,U+1EA0-1EF9,U+20AB}'
    + '@font-face{font-family:"SCW Sans";font-weight:600;font-display:swap;src:url(' + F + 'scr-fonts-bevietnampro-600-latin.woff2) format("woff2")}'
    + '.scw{--ink:#3D1F2B;--rose:#D12E5F;--rose-d:#A81E4A;--pink-l:#FFE4EC;--line:#EBD3DC;--muted:#8A6B77;position:fixed;inset:0;z-index:2147483200;display:flex;align-items:center;justify-content:center;padding:20px;font:400 15px/1.55 "SCW Sans",system-ui,sans-serif;color:var(--ink);-webkit-font-smoothing:antialiased}'
    + '.scw *{box-sizing:border-box;margin:0}'
    + '.scw-bg{position:absolute;inset:0;background:rgba(61,31,43,.48);backdrop-filter:blur(3px);opacity:0;transition:opacity .3s ease}'
    + '.scw-card{position:relative;display:grid;grid-template-columns:5fr 6fr;width:min(940px,100%);max-height:calc(100vh - 40px);overflow:hidden;background:#fff;border-radius:16px;box-shadow:0 30px 80px rgba(61,31,43,.3);opacity:0;transform:translateY(16px) scale(.98);transition:opacity .35s ease,transform .45s cubic-bezier(.2,.8,.2,1)}'
    + '.scw.in .scw-bg{opacity:1}.scw.in .scw-card{opacity:1;transform:none}'
    + '.scw-img{position:relative;background:var(--pink-l) center/cover no-repeat;min-height:500px}'
    + '.scw-badge{position:absolute;left:18px;bottom:18px;background:#fff;color:var(--rose);font:700 13px/1 "SCW Sans",sans-serif;padding:9px 13px;border-radius:8px;box-shadow:0 6px 18px rgba(61,31,43,.15)}'
    + '.scw-body{padding:52px 48px 36px;display:flex;flex-direction:column;justify-content:center;overflow:auto}'
    + '.scw-eye{font:600 12px/1 "SCW Sans",sans-serif;letter-spacing:.14em;text-transform:uppercase;color:var(--rose);margin-bottom:12px}'
    + '.scw-h{font:800 52px/1 "SCW Baloo",system-ui,sans-serif;letter-spacing:-.01em}'
    + '.scw-h span{color:var(--rose)}'
    + '.scw-sub{font:700 20px/1.25 "SCW Baloo",system-ui,sans-serif;margin:6px 0 12px}'
    + '.scw-p{color:var(--muted);font-size:14.5px;margin-bottom:22px}'
    + '.scw-f{display:grid;gap:12px}'
    + '.scw-in{width:100%;height:52px;border:1.5px solid var(--line);border-radius:10px;padding:0 16px;font:inherit;color:var(--ink);background:#fff;outline:none;transition:border-color .2s,box-shadow .2s}'
    + '.scw-in::placeholder{color:#B49AA4}'
    + '.scw-in:focus{border-color:var(--rose);box-shadow:0 0 0 4px rgba(209,46,95,.12)}'
    + '.scw-in.err{border-color:#D93B3B}'
    + '.scw-btn{width:100%;height:56px;border:0;border-radius:10px;background:var(--rose);color:#fff;font:700 15.5px/1 "SCW Sans",sans-serif;cursor:pointer;transition:background .2s,transform .1s;display:flex;align-items:center;justify-content:center;gap:8px}'
    + '.scw-btn:hover{background:var(--rose-d)}.scw-btn:active{transform:scale(.98)}.scw-btn[disabled]{opacity:.7;cursor:wait}'
    + '.scw-msg{font-size:13px;color:#D93B3B}.scw-msg:empty{display:none}'
    + '.scw-fine{font-size:12px;color:var(--muted);margin-top:4px}'
    + '.scw-later{align-self:center;margin-top:14px;background:none;border:0;color:var(--muted);font:600 13px "SCW Sans",sans-serif;text-decoration:underline;text-underline-offset:3px;cursor:pointer}'
    + '.scw-x{position:absolute;top:14px;right:14px;width:38px;height:38px;border:0;border-radius:50%;background:rgba(255,255,255,.92);color:var(--ink);cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:2;transition:background .2s}'
    + '.scw-x:hover{background:var(--pink-l)}'
    + '.scw-code{display:flex;align-items:center;justify-content:space-between;gap:12px;border:2px dashed var(--rose);border-radius:10px;padding:12px 12px 12px 20px;margin:4px 0 14px;background:#FFF7FA}'
    + '.scw-code b{font:800 26px/1 "SCW Baloo",sans-serif;letter-spacing:.06em;color:var(--rose)}'
    + '.scw-copy{height:40px;padding:0 16px;border:0;border-radius:8px;background:var(--ink);color:#fff;font:600 13px "SCW Sans",sans-serif;cursor:pointer}'
    + '.scw-ok{font-size:13.5px;color:#2E8A62;margin-bottom:18px}'
    + '.scw-spin{width:18px;height:18px;border:2px solid rgba(255,255,255,.5);border-top-color:#fff;border-radius:50%;animation:scwspin .7s linear infinite}'
    + '@keyframes scwspin{to{transform:rotate(360deg)}}'
    + '@media(max-width:700px){.scw{align-items:flex-end;padding:0}.scw-card{grid-template-columns:1fr;border-radius:16px 16px 0 0;max-height:92vh;transform:translateY(40px)}'
    + '.scw-img{min-height:150px}.scw-body{padding:26px 22px 22px}.scw-h{font-size:42px}.scw-sub{font-size:18px}.scw-p{margin-bottom:16px}}'
    + '@media(prefers-reduced-motion:reduce){.scw-bg,.scw-card{transition:none}}';

  var root, lastFocus;
  var X_SVG = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  function build() {
    if (root) return;
    var st = D.createElement('style'); st.id = 'scw-css'; st.textContent = CSS; D.head.appendChild(st);
    root = D.createElement('div');
    root.className = 'scw';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-labelledby', 'scw-title');
    root.innerHTML = ''
      + '<div class="scw-bg" data-scw="close"></div>'
      + '<div class="scw-card">'
      + '<button type="button" class="scw-x" data-scw="close" aria-label="Đóng">' + X_SVG + '</button>'
      + '<div class="scw-img"' + (C.image ? ' style="background-image:url(\'' + C.image + '\')"' : '') + '><span class="scw-badge">Simple Candy · Hội An & Đà Nẵng</span></div>'
      + '<div class="scw-body" id="scw-body">'
      + '<p class="scw-eye">Quà cho lần đầu ghé</p>'
      + '<h2 class="scw-h" id="scw-title">Giảm <span>' + PCT + '%</span></h2>'
      + '<p class="scw-sub">cho đơn hàng đầu tiên</p>'
      + '<p class="scw-p">Để lại email, Simple Candy gửi bạn mã ưu đãi cùng tin workshop và vị kẹo mới mỗi tháng.</p>'
      + '<form class="scw-f" method="post" action="/contact#scw" accept-charset="UTF-8" novalidate>'
      + '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓">'
      + '<input type="hidden" name="contact[tags]" value="newsletter, popup-' + PCT + '">'
      + '<input class="scw-in" type="text" name="contact[first_name]" placeholder="Tên của bạn" autocomplete="given-name">'
      + '<input class="scw-in" type="email" name="contact[email]" placeholder="Email *" autocomplete="email" required>'
      + '<p class="scw-msg" role="alert"></p>'
      + '<button class="scw-btn" type="submit">Nhận mã giảm ' + PCT + '%</button>'
      + '<p class="scw-fine">Không spam. Bạn có thể huỷ đăng ký bất cứ lúc nào.</p>'
      + '</form>'
      + '<button type="button" class="scw-later" data-scw="close">Để sau</button>'
      + '</div></div>';
    D.body.appendChild(root);
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-scw]'); if (!a) return;
      if (a.dataset.scw === 'close') close();
      if (a.dataset.scw === 'copy') copy(a);
    });
    root.querySelector('form').addEventListener('submit', submit);
    D.addEventListener('keydown', onKey);
  }

  function open() {
    build();
    lastFocus = D.activeElement;
    D.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { root.classList.add('in'); });
    setTimeout(function () { var i = root.querySelector('input[type=email]'); i && i.focus({ preventScroll: true }); }, 350);
  }

  function close() {
    if (!root) return;
    var s = store(); if (!s || s.s !== 'done') try { sessionStorage.setItem(SKEY, '1'); } catch (e) {}
    root.classList.remove('in');
    D.documentElement.style.overflow = '';
    D.removeEventListener('keydown', onKey);
    setTimeout(function () { root && root.remove(); root = null; }, 350);
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
    if (e.key === 'Tab' && root) { // giữ focus trong popup
      var f = root.querySelectorAll('button,input,[href]'), first = f[0], last = f[f.length - 1];
      if (e.shiftKey && D.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && D.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function submit(e) {
    e.preventDefault();
    var form = e.target, email = form.querySelector('input[type=email]'), msg = form.querySelector('.scw-msg'), btn = form.querySelector('.scw-btn');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim())) {
      email.classList.add('err'); msg.textContent = 'Email chưa đúng, bạn kiểm tra lại nhé.'; email.focus(); return;
    }
    email.classList.remove('err'); msg.textContent = '';
    btn.disabled = true; btn.innerHTML = '<span class="scw-spin"></span>';
    store({ s: 'sent', t: Date.now(), email: email.value.trim() });
    // Gửi bằng form chuyển trang: Shopify có lớp chống bot (Cloudflare) nên gửi ngầm (fetch) bị chặn 403.
    // Shopify lưu khách hàng (Khách hàng › tag popup-20) rồi quay về trang này kèm ?customer_posted=true → hiện mã.
    form.removeEventListener('submit', submit);
    form.submit();
  }

  function success() {
    store({ s: 'done', t: Date.now() });
    fetch('/discount/' + encodeURIComponent(CODE) + '?redirect=%2Fcart.js', { credentials: 'same-origin' }).catch(function () {}); // áp mã sẵn vào giỏ
    var body = root.querySelector('#scw-body');
    body.innerHTML = ''
      + '<p class="scw-eye">Đăng ký thành công</p>'
      + '<h2 class="scw-h" id="scw-title" style="font-size:40px">Mã của bạn đây!</h2>'
      + '<p class="scw-p" style="margin:10px 0 16px">Giảm ' + PCT + '% cho đơn hàng đầu tiên tại Simple Candy.</p>'
      + '<div class="scw-code"><b>' + CODE + '</b><button type="button" class="scw-copy" data-scw="copy">Sao chép</button></div>'
      + '<p class="scw-ok">✓ Mã đã được áp sẵn vào giỏ hàng của bạn.</p>'
      + '<button type="button" class="scw-btn" data-scw="close">Bắt đầu mua sắm</button>';
    if (!root.classList.contains('in')) open();
  }

  function copy(btn) {
    var done = function () { btn.textContent = 'Đã chép ✓'; setTimeout(function () { btn.textContent = 'Sao chép'; }, 1800); };
    if (navigator.clipboard) navigator.clipboard.writeText(CODE).then(done, done); else done();
  }

  // Hiện sau DELAY ms, khi trang custom (nếu có) đã hiện xong và tab đang mở
  ready(function () {
    var t0 = Date.now();
    (function wait() {
      var booting = D.documentElement.classList.contains('scr-boot') || (W.__scRef && !D.documentElement.classList.contains('scr-on'));
      if (Date.now() - t0 < DELAY || booting || D.hidden) return setTimeout(wait, 400);
      open();
    })();
  });

  W.SCPopup = { open: open, close: close, reset: function () { try { localStorage.removeItem(KEY); } catch (e) {} } };
})();
